<template>
  <li
    :class="[
      'notification-message',
      { 'notification-message--is-seen': isSeen },
    ]"
  >
    <header class="notification-message__title">{{ title }}</header>
    <div v-dompurify-html="text" class="notification-message__content" />
    <div v-if="buttonText" class="notification-message__action">
      <a
        class="notification-message__button"
        :href="buttonLink"
        target="_blank"
      >
        {{ buttonText }}
      </a>
    </div>
  </li>
</template>

<script>
export default {
  name: 'NotificationMessage',

  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    buttonLink: {
      type: String,
      default: '',
    },
    isSeen: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.notification-message {
  list-style: none;
  border-radius: 6px;

  padding: $global-padding;
  padding-bottom: $global-padding * 0.8;

  & + & {
    border-top: 1px solid #eee;
  }

  &__title {
    font-weight: bold;
    margin-bottom: $global-margin / 2;
  }

  $base: &;

  &--is-seen {
    opacity: 0.6;

    #{$base}__title {
      font-weight: normal;
    }
  }

  &__action {
    margin-top: $global-margin;
    text-align: right;

    @include rtl() {
      text-align: left;
    }
  }

  &__content {
    overflow-x: hidden;
    text-align: left;
    word-wrap: break-word;
    white-space: normal;
    word-break: break-word;
    line-height: 1.6;

    @include rtl() {
      text-align: right;
    }

    p {
      margin: 0;
      line-height: 1.6;
      white-space: normal;
    }

    b,
    strong {
      font-weight: bold;
    }
  }

  &__button {
    color: $lb-color-primary;
  }
}
</style>
